// extracted by mini-css-extract-plugin
export default {"insCertTable":"AdminReports_insCertTable__5a1EE"};